import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';

const KEY = 'adoptic_cookie_consent';

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem(KEY)) setShow(true); }, []);
  const accept = () => { localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); setShow(false); };
  if (!show) return null;
  return (
    <div role="dialog" aria-label="Cookie notice" data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-[12px] border border-ink/10 bg-white/95 backdrop-blur-md shadow-2xl p-4 flex gap-3 animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="w-9 h-9 rounded-[8px] bg-brand-orange/10 flex items-center justify-center shrink-0"><Cookie className="w-4 h-4 text-brand-orange" /></div>
      <div className="flex-1 min-w-0">
        <p className="font-body text-xs text-ink/80 leading-relaxed">
          Adoptic uses strictly necessary cookies and local storage to keep you signed in and remember your preferences — no advertising trackers. Read our <Link to="/cookies" className="underline text-ink hover:text-brand-orange" data-testid="cookie-banner-policy-link">Cookie Use</Link> policy.
        </p>
        <div className="flex items-center gap-2 mt-3">
          <Button size="sm" onClick={accept} data-testid="cookie-banner-accept" className="h-8 bg-ink hover:bg-ink/90 text-white font-body text-xs">Got it</Button>
          <Link to="/cookies" className="font-body text-xs text-ink/60 hover:text-ink underline" data-testid="cookie-banner-learn-more">Learn more</Link>
        </div>
      </div>
    </div>
  );
};
